const normalizeString = (str: string = '') => str.trim().toLowerCase();

export default normalizeString;
